import { ajax } from 'rxjs/ajax'
import { retry, map } from 'rxjs/operators'
import envGet from 'Support/Env/Get/EnvGet.support'
import { ServiceHeadersContentTypeJson } from 'Constants/Service/json-headers'
import { Account } from 'types/Account'

const BASE_URL_FLITCH = envGet({ key: `REACT_APP_BORAL_BASE_URL_FLITCH` }) as string
const ACCOUNT_DEFAULT_PROJECT = envGet({ key: `REACT_APP_BORAL_ACCOUNT_DEFAULT_PROJECT` }) as string

interface Options {
  account: Account,
  authHeaders: any,
}

const getDefaultProjectForAccountService = async (options: Options): Promise<{ projectCode: string }> => {
  const {
    account,
    authHeaders = {},
  } = options

  const headers = {
    ...authHeaders,
    ...ServiceHeadersContentTypeJson,
  }
  const url = `${BASE_URL_FLITCH}${ACCOUNT_DEFAULT_PROJECT.replace(`{ACCOUNT}`, account.id.trim())}`

  return ajax({
    headers,
    url,
  })
    .pipe(
      retry(1),
      map((e) => e.response),
    )
    .toPromise()
}

export default getDefaultProjectForAccountService
